/* esm.sh - applesauce-core@5.2.0/dist/logger */
import e from"debug";var p=e("applesauce");export{p as logger};
//# sourceMappingURL=logger.mjs.map